import { render, staticRenderFns } from "./t-msg.vue?vue&type=template&id=e89a7210&scoped=true&"
import script from "./t-msg.vue?vue&type=script&lang=js&"
export * from "./t-msg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e89a7210",
  null
  
)

export default component.exports